import React from "react";

function Icon1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_302_35)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M17 13.984V6.016H7.016V9H5V4.984C5 4.47 5.469 4 5.984 4h12c.563 0 1.032.469 1.032.984V8.5L23 4.516v10.968L19.016 11.5v3.516c0 .515-.47.984-1.032.984H13v-2.016h4z"
          clipRule="evenodd"
        ></path>
        <path
          stroke="#fff"
          strokeWidth="1.5"
          d="M6 21a5 5 0 100-10 5 5 0 000 10z"
        ></path>
        <path
          fill="#fff"
          d="M8 18l-1.351-4H5.35L4 18h1.07l.195-.624h1.47L6.93 18H8zm-1.514-1.455h-.972L6 14.966l.486 1.579z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_302_35">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon1;